import { CallBackEndService } from '../../call-back-end.service';
import { Component, OnInit } from '@angular/core';

import { IbRequest } from '../../ib-request';
import { IbResponse } from '../../ib-response';
import { AuthenticationService } from '../../service/authentication.service';
import {Router} from "@angular/router";
declare var getHexAscii:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
 private shown: string = 'EQUIFAX';
   scAccount : string ;
   scAccounts : any =[];
  Scaccountmini : any =[];
   accountHolderName: string =sessionStorage.getItem('storedUserName');
    accountInfo : any ;
    //isFundTransferProvided:String='no';
    financialTrYN=''; //yes or no
   constructor(private webService: CallBackEndService,
               private router: Router
   ) {
    let loginTab =sessionStorage.getItem('userLoggedInForOnePage');
    console.log('vall--------'+loginTab);
    if(loginTab!=null && loginTab==='yes'){
      this.financialTrYN=sessionStorage.getItem('financialTrYN');
      console.log('financialTrYN:-------------'+this.financialTrYN);  
    }else{      
      router.navigate(['/login']);
      }

   

    
      
    //  this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    //  this.Scaccountmini=sessionStorage.getItem('scoAccounts');
    // // this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));
    //  console.log("sc accounts "+this.scAccounts);
    //  this.scAccount=this.scAccounts[0];
    //   const request: IbRequest = new IbRequest();
    // let response: IbResponse = null;
    // request.param1 = getHexAscii('', this.scAccount);
    // request.param2 = this.scAccount;
    // this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
    //   if (data !== null && data.status === 'S200') {
    //     this.accountInfo = data.param5;
    //    sessionStorage.setItem('miniAccounSelected', this.scAccount);
    // sessionStorage.setItem('miniSelectedBalance', data.param5.clrBalanceStr);
    // sessionStorage.setItem('miniSelectedName', data.param5.fullName);
    // sessionStorage.setItem('minidModuleType', data.param5.moduleType);
    //    sessionStorage.setItem('miniAcctlist', this.Scaccountmini);
        
    //     //this.showLoanAmount ='Hide';
    //   }
    // });
   }
  ngOnInit() {
    this.router.events.subscribe(function(l){
      setTimeout(function(){
        history.pushState("","",document.URL),
          window.addEventListener("popstate",function(l){history.forward();});

      },500);

    });
  }


  ScAcctInfo()
  {
     //this.scAccount=this.scAccounts[0];
    console.log("call service ")
      const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.scAccount);
    request.param2 = this.scAccount;
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200') {
        this.accountInfo = data.param5;
         sessionStorage.setItem('miniAccounSelected', this.scAccount);
    sessionStorage.setItem('miniSelectedBalance', data.param5.clrBalanceStr);
    sessionStorage.setItem('miniSelectedName', data.param5.fullName);
    sessionStorage.setItem('minidModuleType', data.param5.moduleType);
       sessionStorage.setItem('miniAcctlist', this.scAccounts);
        console.log("changing data"+this.accountInfo);
        //this.showLoanAmount ='Hide';
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/dashboard/dashboard.component.ts